import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import Bubbles from '@root/components/Bubbles';
import ProductsSliderBubbles, {
  SymptomsSliderBubbles,
} from '@root/components/ProductsSliderBubbles';
import SintomasPicotSlider, { SintomasPicotPlusSlider } from '@root/components/SintomasPicotSlider';
import SintomasSlider from '@root/components/SintomasSlider';

import {
  ProductSliderBubblesMock,
  SintomasPicotPlusSliderMock,
  SintomasPicotSliderMock,
  SintomasSliderMock,
  SymptomsSliderBubblesMock,
} from './custom-components-mocks';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'bubbles',
        component: Bubbles,
      },
      {
        key: 'productSliderBubbles',
        component: () => <ProductsSliderBubbles {...ProductSliderBubblesMock} />,
      },
      {
        key: 'symptomsSliderBubbles',
        component: () => <SymptomsSliderBubbles {...SymptomsSliderBubblesMock} />,
      },
      {
        key: 'sintomasSlider',
        component: () => <SintomasSlider {...SintomasSliderMock} />,
      },
      {
        key: 'sintomasPicotSlider',
        component: () => <SintomasPicotSlider {...SintomasPicotSliderMock} />,
      },
      {
        key: 'sintomasPicotPlusSlider',
        component: () => <SintomasPicotPlusSlider {...SintomasPicotPlusSliderMock} />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
